import { render, staticRenderFns } from "./object-input.vue?vue&type=template&id=4428693c&scoped=true&"
import script from "./object-input.vue?vue&type=script&lang=js&"
export * from "./object-input.vue?vue&type=script&lang=js&"
import style0 from "./object-input.vue?vue&type=style&index=0&id=4428693c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4428693c",
  null
  
)

export default component.exports